/* eslint-disable react/jsx-props-no-spreading -- the swipe handlers are a set of event props */
import React from 'react';
import { Modal } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { useSwipeDownToClose } from '../../../common/views/modals/confirmDialog/useSwipeDownToClose';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './DayPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Below 700 px the day panel is a bottom sheet (design c2): the same content and actions. Drag the
 * grab handle down or press Escape to close it.
 */
const PostSheetComponent: React.FC<PostSheetProps> = ({ isOpen, onClose, children }) => {
  const swipe = useSwipeDownToClose(onClose);
  return (
    <Modal isOpen={isOpen} toggle={onClose} className={styles.sheet} contentClassName={styles.sheetContent}>
      <div className={styles.grab} aria-hidden="true" {...swipe} />
      {children}
    </Modal>
  );
};

export const PostSheet = TypedMemo(PostSheetComponent);
